import Isotope from 'isotope-layout';

export default {
  init() {
    // JavaScript to be fired on the branch page, after the init JS

    // vanilla JS
    var grid = document.querySelector('.immo-grid');
    var iso = new Isotope( grid, {
      itemSelector: '.immo-item',
      percentPosition: true,
      layoutMode: 'fitRows',
      stagger: 30,
    });

    window.addEventListener('load', () => {
      window.dispatchEvent(new Event('resize'));
    });

    var filterFns = {
      // show if number is greater than 50
      numberGreaterThan50: function() {
        var number = $(this).find('.number').text();
        return parseInt( number, 10 ) > 50;
      },
      // show if name ends with -ium
      ium: function() {
        var name = $(this).find('.name').text();
        return name.match( /ium$/ );
      },
    };

    // bind filter on select change
    $('.filters-select').on( 'change', function() {
      // get filter value from option value
      var filterValue = this.value;
      // use filterFn if matches value
      filterValue = filterFns[ filterValue ] || filterValue;
      iso.arrange({ filter: filterValue });
    });
      

  },
  finalize() {
      // JavaScript to be fired on the immo page

      $('[data-toggle="tooltip"]').tooltip();
      
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/immo.js